import { render, staticRenderFns } from "./index.vue?vue&type=template&id=282c5920&scoped=true&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=282c5920&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282c5920",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('282c5920')) {
      api.createRecord('282c5920', component.options)
    } else {
      api.reload('282c5920', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=282c5920&scoped=true&lang=pug", function () {
      api.rerender('282c5920', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/class/vipClassroom/enterClassroom/index.vue"
export default component.exports